import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ContentConverterQuery: GraphQLTaggedNode = graphql`
	query ContentConverterQuery(
		$content: String!
		$contentId: ID!
		$from: String!
		$to: String!
		$spaceKeyContext: String = ""
	) {
		contentConverter(
			from: $from
			to: $to
			content: $content
			contentIdContext: $contentId
			spaceKeyContext: $spaceKeyContext
		) {
			value
		}
	}
`;
